import { render, staticRenderFns } from "./LabResultCheck.vue?vue&type=template&id=7d3b1f33&scoped=true&"
import script from "./LabResultCheck.vue?vue&type=script&lang=js&"
export * from "./LabResultCheck.vue?vue&type=script&lang=js&"
import style0 from "./LabResultCheck.vue?vue&type=style&index=0&id=7d3b1f33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3b1f33",
  null
  
)

export default component.exports